var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsChartTypesScatter = function SvgIconsChartTypesScatter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.25 16.5c1.24 0 2.25 1.01 2.25 2.25S7.49 21 6.25 21 4 19.99 4 18.75s1.01-2.25 2.25-2.25zM17 13.2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm-6.213-3.212c1.324 0 2.4 1.076 2.4 2.4 0 1.323-1.076 2.4-2.4 2.4a2.403 2.403 0 0 1-2.4-2.4c0-1.324 1.077-2.4 2.4-2.4zM7 4c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm9.4-1c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
  }))));
};
export default SvgIconsChartTypesScatter;